import { useEffect, useState } from "react";
import Addandeditform from "../shared/components/PYQs/Addandeditform";
import Tableheadpanel from "../shared/components/PYQs/Tableheadpanel";
import { apideletepyqs, apisavePYQ, apiupdatePYQ, getadminpyqs } from "../shared/services/apiPyq/apipyq";
import toast from "react-hot-toast";
import Tableview from "../shared/components/PYQs/Tableview";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";

export default function Pyqpage () {

    const [visible, setVisible] = useState(false);
    const [formdata,setformdata]=useState({});
    const [page, setPage] = useState(1);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);
    const [tableData, setTableData] = useState();
    const [globalFilter, setGlobalFilter] = useState('');
    const [tempFilterValues, setTempFilterValues] = useState([]);
    const [loading, setLoading] = useState(false);

    const openform=()=>{
        setformdata({});
        setVisible(true)
    }

    const handlechange=(e)=>e.target.files?setformdata({...formdata,...{[e.target.name]:e.target.files[0]}}):setformdata({...formdata,[e.target.name]:e.target.value});

    const handlesave = async (e) => {
        e.preventDefault();
        const res = await apisavePYQ(formdata);
        console.log(res);
        if (res.message === "Successfully saved") {
            toast.success(res.message)
            setVisible(false)
            await getadminpyqs();
        } else {
            toast.error(res.message);
        }
    };

    useEffect(()=>{
        getadminpyqs({first, rows, globalFilter}).then((res)=>{
            if(res?.resdata) setTableData(res.resdata);}).catch((err) => console.log(err)).finally(setLoading(false))
    },[first, rows, globalFilter]);

    const onPage = (pages) => {
        setPage(pages);
        // console.log(rows,pages )
        setFirst(pages.first);
        setRows(rows);
    };

    const cusfilter = (field, value) => {
        setcolFilter(prev => ({ ...prev, [field]: {$in:value} }));
        setFirst(0);
    };

    const editfrom=(data)=>{
        setformdata(data);
        setVisible(true);
    }

    const clearFilter = (event)=>{
        setcolFilter(null);
        setGlobalFilter('')
        setTempFilterValues([])
        setFirst(0)
    }

    const handleupdate=async (e)=>{
        e.preventDefault()
        setLoading(true)
        await apiupdatePYQ(formdata._id, formdata)
        console.log(formdata)
        toast.success("Sucessfully updated")
        getadminpyqs({first, rows, globalFilter})
        setVisible(false)
        setLoading(false)
    };

    const handledelete = (id) => {
        confirmDialog({
            message: 'Do you want to delete this record?',
            header: 'Delete Confirmation',
            icon: 'pi pi-info-circle',
            defaultFocus: 'reject',
            acceptClassName: 'bg-red-500 ml-2 text-white p-2',
            rejectClassName: 'p-2 outline-none border-0',
            accept:async ()=>{
             await apideletepyqs(id)
             toast.success("Successfully deleted")
             apideletepyqs();
            }
        });
    };

    return (
        <>
        <Tableheadpanel openform={openform} setGlobalFilter={setGlobalFilter}/>
        <Addandeditform visible={visible} setVisible={setVisible} formdata={formdata} handlechange={handlechange} handlesave={handlesave} handleupdate={handleupdate} />
        <Tableview loading={loading} onPage={onPage} tableData={tableData} totallength={tableData?.totallength} cusfilter={cusfilter} editfrom={editfrom}
                 clearFilter={clearFilter} tempFilterValues={tempFilterValues} setTempFilterValues={setTempFilterValues} first={first} handledelete={handledelete} />
        <ConfirmDialog />
        </>
    )
}